module.exports = __webpack_public_path__ + "img/Dribbble.dddb7f64.svg";